<template>
<nav-tabs :tabs="tabs"
	addon-apps-location="Equipment Module"
	addon-apps-link="/equipment/apps">
</nav-tabs>

</template>
<script type="text/javascript">
import NavTabs from "@/layout_fragments/NavTabs"

export default {
	name: "EquipmentListNavTabs",
	components: {
		NavTabs
	},
	computed: {
		tabs() {
			let tabs = [
					{label: 'Equipment',path: '/equipment/list',icon:'fa-list'},
					{label: 'Forms',path: '/equipment/forms',icon:'fa-clipboard-check'},
					{label: 'Maintenance Schedule',path: '/equipment/maintenance-schedule',icon:'fa-wrench'},
					{label: 'Fleet Tracking',path: "/equipment/geo-tracking",icon: 'fa-satellite'}
				]

			if (this.hasModulePermWrite('Equipment')) 
				tabs.push({label: 'Settings',path: '/equipment/settings',icon:'fa-cog'})

			return tabs
		}
	}
}
</script>